const exportColumns = [
    'id',
    'dealVersionKey.version',
    'dealVersionKey.dealId',
    'dealVersionKey.createdById',
    'dealVersionKey.createdDate',
    'dealVersionKey.executedActionId',
    'snapshotDescription',
    'subordinateObjectIdentifier',
    'parentReference',
    'body.template.templateId',
    'body.template.processId',
    'body.template.templateName',
    'body.id',
    'body.title',
    'body.createdById',
    'body.status.statusId',
    'body.status.statusName',
    'body.characteristics.deal_currency.id',
    'body.characteristics.deal_currency.value',
    'body.characteristics.deal_short_name',
    'body.characteristics.deal_version',
    'body.characteristics.contract_executed_date',
    'body.characteristics.minimum_guarantee.locAmt',
    'body.characteristics.minimum_guarantee.locSym',
    'body.characteristics.minimum_guarantee.locCur',
    'body.characteristics.minimum_guarantee.divAmt',
    'body.characteristics.minimum_guarantee.divCur',
    'body.characteristics.minimum_guarantee.divSym',
    'body.characteristics.total_license_fee.locAmt',
    'body.characteristics.total_license_fee.locSym',
    'body.characteristics.total_license_fee.locCur',
    'body.characteristics.total_license_fee.divAmt',
    'body.characteristics.total_license_fee.divCur',
    'body.characteristics.total_license_fee.divSym',
    'body.characteristics.total_license_fee_calculation_allowed.id',
    'body.characteristics.total_license_fee_calculation_allowed.xref',
    'body.characteristics.total_license_fee_calculation_allowed.value',
    'body.characteristics.total_license_fee_calculation_message',
    'body.characteristics.last_amended_by_name',
    'body.characteristics.last_amended_by_email',
    'body.characteristics.last_amended_by_timestamp',
    'body.characteristics.last_amended_action',
    'body.characteristics.mediamorph_allocation.locAmt',
    'body.characteristics.mediamorph_allocation.locSym',
    'body.characteristics.mediamorph_allocation.locCur',
    'body.characteristics.mediamorph_allocation.divAmt',
    'body.characteristics.mediamorph_allocation.divCur',
    'body.characteristics.mediamorph_allocation.divSym',
    'body.characteristics.606_backlog_allocation.locAmt',
    'body.characteristics.606_backlog_allocation.locSym',
    'body.characteristics.606_backlog_allocation.locCur',
    'body.characteristics.606_backlog_allocation.divAmt',
    'body.characteristics.606_backlog_allocation.divCur',
    'body.characteristics.606_backlog_allocation.divSym',
    'body.characteristics.user_friendly_id',
    'body.lastUpdatedDate',
    'body.createdDate',
    'body.lastUpdatedById',
    'body.revisionId',
    'body.searchableTitle',
    'createdAt'
];

const exportColumnHeaders = {
    snapshotDescription: 'Snapshot',
};

function getValue(obj, path) {
    return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : ''), obj);
}

export function flattenDealVersions(content) {
    const rows = [];
    content?.forEach(item => {
        const row = {};
        exportColumns.forEach(key => {
            const header = exportColumnHeaders[key] || key;
            row[header] = getValue(item, key);
        });
        rows.push(row);
    });
    return rows;
}